module.exports = __webpack_public_path__ + "static/media/icon-online.3eb7a622.svg";